export const PERMISSION_SET = '@@permission/PERMISSION_SET';
